export function Equipments() {
    return <div>
        Equipments
    </div>
}